import React from 'react';
import DungeonBoard from './DungeonBoard';
import DarknessVignette from '../../ui/overlays/DarknessVignette';
import SanityCollapseGlitch from '../../ui/overlays/SanityCollapseGlitch';

/**
 * ExplorationScene isolates the dungeon board rendering from the rest of App.
 * By memoizing this component and only passing the state it actually needs,
 * changes to unrelated UI (e.g. modals or HUD overlays) will not cause the
 * board to rerender. This improves performance during exploration.
 */
function ExplorationScene({
  boardRefs,
  boardState,
  renderState,
  tileActions,
  tileHelpers,
  tileAssets,
  sanityFx,
  sanityCollapseBurst,
  lowFx = false,
  aggressiveLowFx = false,
}) {
  return (
    <>
      <DungeonBoard
        boardRefs={boardRefs}
        boardState={boardState}
        renderState={renderState}
        tileActions={tileActions}
        tileHelpers={tileHelpers}
        tileAssets={tileAssets}
      />
      <DarknessVignette
        active={sanityFx.enabled && sanityFx.tier >= 1}
        intensity={sanityFx.vignetteOpacity}
        pulseStrength={sanityFx.vignettePulseOpacity}
        madness={sanityFx.madness}
        lowFx={lowFx}
        aggressiveLowFx={aggressiveLowFx}
      />
      <SanityCollapseGlitch
        active={sanityFx.collapseActive}
        sanityFx={sanityFx}
        burst={sanityCollapseBurst}
        lowFx={lowFx}
        aggressiveLowFx={aggressiveLowFx}
      />
    </>
  );
}

export default React.memo(ExplorationScene);